module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Zuerich_matt-29d26cda2d884502a628ee73fa3f9ded.svg";